export default function Icon1() {
    return (
        <svg width="81" height="80" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40.167 4V76.3333" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M72.5 21.333L7.83333 58.6663" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M72.499 59.335L7.83322 22.0001" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M62.1662 14.667L58.0576 30.0003L73.1662 34.0003" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M7.10036 46.2741L22.5292 50.008L18.8076 65.1875" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M18.8338 14.667L22.9424 30.0003L7.83382 34.0003" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M73.3165 46.2316L57.9703 50.2917L62.0128 65.3889" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M29.5 9.66699L40.1667 20.0003L51.1667 10.0003" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
            <path d="M29.5 71L40.1667 60.6667L51.1667 70.6667" stroke="black" strokeWidth="3.33333" strokeLinecap="round" />
        </svg>
    );
}
